import { makeStyles, Typography } from "@material-ui/core";
import {Link} from '@portal/arq-portal-core';
import React from "react";


const Admin = (props:any) => { 

    const useStyles = makeStyles(theme => ({
        linea: {
        padding: theme.spacing(1)
        }, 
        container:{
            display: 'flex',
            flexDirection: 'column', 
            padding: '1.5rem',
            backgroundColor: 'white'
        },
        header:{
            fontFamily: "CO-Bold",
            fontSize: '18px',
            color: '#606060', 
            borderBottom: '1px solid #919191',
            paddingBottom: '15px',
            marginBottom: '10px',
        },
        cargaVacios: {
            padding: "20px", 
            width: "100%", 
            textAlign: "center", 
            fontSize: '14px',
            color: '#606060',
        },
        listItem: {
            display: 'flex',
            flexDirection: 'column', 
            padding: '15px',
            paddingBottom: '30px',
            backgroundColor: 'white'
        }, 
        item:{
            borderBottom: '1px solid #d6d8d8',
            fontSize: '12px',
            color: '#606060',
            fontFamily: "Catalana-sans",
            cursor: 'pointer',
            display: 'flex',
            padding: '6px 0',
            alignItems: 'center',
            justifyContent: 'space-between',
            '&:hover':{
                color: '#919191',
            },
            '&:focus, &:active':{
                color: '#DC0028',
            }
        }
    }));

    const classes = useStyles(props);
    let enlaces = [
        {Url: "/_admin/meinteresa", Titulo: "Me interesa"},
        {Url: "/_admin/marquesinas", Titulo: "Marquesinas"},
        {Url: "/_admin/resultadosfinancieros", Titulo: "Resultados Financieros"},
        {Url: "/_admin/enlaces", Titulo: "Administración de enlaces"},
        {Url: "/_admin/audiencias", Titulo: "Administración de audiencias"},
        {Url: "/_admin/roles", Titulo: "Administración de roles"},
        {Url: "/_admin/componentes", Titulo: "Administración de componentes"},
        {Url: "/_admin/configpuntomenu", Titulo: "Administración de configuración de puntos de menu"},
        {Url: "/_admin/suscripciondescargaficheros", Titulo: "Administración suscripción descarga ficheros"}
    ];
    let desarrollo = window.location.hostname.startsWith("d") || window.location.hostname.startsWith("w") || window.location.hostname.startsWith("localhost");
    if(desarrollo){
        let extra =  [
            {Url: "/_admin/puntosbloqueadosmicrostrategy", Titulo:"Administración de puntos bloqueados Microstrategy"}
          ]
      enlaces = enlaces.concat(extra);
    }

    return (
    <div className = {classes.container}>
       <h3 className={classes.header}>Administración del portal</h3>
            
       <div className = {classes.listItem}>
        {enlaces.map ((item) => <Link className={classes.item} to = {item.Url}><Typography style={{flex: "1"}} variant="inherit">{item.Titulo}</Typography></Link>)}
        </div>
    </div>
    );
}

export default Admin;